import { render, staticRenderFns } from "./AiReportStatus.vue?vue&type=template&id=06f2fa9d"
import script from "./AiReportStatus.vue?vue&type=script&lang=js"
export * from "./AiReportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports